var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 62,
    viewBox: "0 0 59 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1719 2.91619L29.5001 2.67661L28.8283 2.9162L4.62188 11.549L3.12474 12.0829L3.30687 13.662L6.99867 45.6679L7.11655 46.6898L8.01647 47.1883L28.5311 58.5506L29.5001 59.0873L30.4691 58.5506L50.9837 47.1883L51.8837 46.6898L52.0015 45.6679L55.6933 13.6615L55.8755 12.0824L54.3783 11.5485L30.1719 2.91619Z",
    fill: "#DD0031",
    stroke: "#001E36",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 4.79999V10.5723V10.5464V56.801L50.0146 45.4387L53.7064 13.4323L29.5 4.79999Z",
    fill: "#C3002F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4999 10.5464L14.3687 44.4764H20.0104L23.0507 36.8836H35.8948L38.9376 44.4769H44.5794L29.4999 10.5464ZM33.9194 32.2036H25.0804L29.4999 21.5695L33.9194 32.2036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.f72974f0bab6d95d5687a4a04d3c4556.svg";
export { ForwardRef as ReactComponent };